import { CallState, LoadingState } from '@lcs/shared/api';
import { createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import { LocationDetailView } from '../models/location-detail-view.model';
import { GetLocationDetail_location } from '../queries/generated/GetLocationDetail';
import * as LocationDetailActions from './location-detail.actions';

export const locationDetailFeatureKey = 'locationDetail';

export interface State {
   location: LocationDetailView | null;
   callState: CallState;
}

export const initialState: State = {
   callState: LoadingState.Init,
   location: null,
};

export const reducer = createReducer(
   initialState,
   onReset(initialState),
   on(LocationDetailActions.locationDetailLoad, LocationDetailActions.locationDetailCancel, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         location: null,
      };
   }),
   on(LocationDetailActions.loadLocationDetailSuccess, (state, action) => {
      const location: GetLocationDetail_location = action.data;
      return {
         ...state,
         callState: LoadingState.Loaded,
         location: {
            ...location,
            createUser: location.createUser?.name as string | null,
            updateUser: location.updateUser?.name as string | null,
         },
      };
   }),
   on(LocationDetailActions.loadLocationDetailFailure, (state, action) => {
      return {
         ...state,
         callState: action,
      };
   }),
   on(LocationDetailActions.saveLocationDetail, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(LocationDetailActions.saveLocationDetailFailure, LocationDetailActions.locationDetailAccessDenied, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   })
);
